export default function CutCornersSection() {
  return null;
}
